<template>
  <Portal
    :to="portalTarget"
    slim
  >
    <div
      class="confirm-dialog-wrapper"
      :class="{ 'transparent': transparentWrapper }"
      @click.self="handleWrapperClick"
    >
      <slot />
    </div>
  </Portal>
</template>

<script>
import { Portal } from 'portal-vue';

export default {
  name: 'ConfirmDialogWrapper',
  components: { Portal },
  props: {
    portalTarget: {
      type: String,
      default: 'portalTarget',
    },
    wrapperClickEvent: {
      type: String,
      default: null,
      validate: (value) => value === null || ['confirm', 'cancel'].includes(value),
    },
    transparentWrapper: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    confirm(event) {
      this.$emit('resolve', event);
    },
    cancel(event) {
      this.$emit('reject', event);
    },
    handleWrapperClick(event) {
      if (this.wrapperClickEvent === 'confirm') {
        this.confirm(event);
      } else if (this.wrapperClickEvent === 'cancel') {
        this.cancel(event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .confirm-dialog-wrapper {
    &.transparent {
      background: transparent;
    }

    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: grid;
    justify-items: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999999;
  }
</style>
